import pinia from '@/store/store';
import { firebaseApp } from '@shared/plugins/firebase';
import logRocket from '@shared/plugins/logRocket';
import openApiClient from '@shared/plugins/openApiClient';
import FloatingVue from 'floating-vue';
import { LDPlugin } from 'launchdarkly-vue-client-sdk';
import smoothscroll from 'smoothscroll-polyfill';
import { createApp } from 'vue';
import VueGtag from 'vue-gtag';
import { VueFire, VueFireAuth } from 'vuefire';

import App from './App.vue';
import i18n from './i18n';
import router from './router';

// polyfill for smooth scroll animation behavior between pages for iOS
smoothscroll.polyfill();

const app = createApp(App);

app.use(openApiClient, { baseUrl: import.meta.env.VITE_OPEN_API_BASE_URL });
app.use(pinia);

if (import.meta.env.VITE_TRACKING_ENABLED == 'true') {
  app.use(logRocket, { appId: import.meta.env.VITE_LOG_ROCKET_APP_ID });
}

app.use(LDPlugin, {
  clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID
});

app.use(router);
app.use(FloatingVue);

app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()]
});

app.use(
  VueGtag,
  {
    appName: 'S3 Internal',
    pageTrackerScreenviewEnabled: true,
    config: { id: import.meta.env.VITE_S3_INTERNAL_GA_MEASUREMENT_ID },
    enabled: import.meta.env.VITE_GA_TRACKING_ENABLED == 'true'
  },
  router
);

app.use(i18n);
app.mount('#app');
